import React from "react";
import { BaseComponent } from "../../utils/BaseComponent";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { Endpoint } from "@schneiderpp/client-endpoint";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { ds } from "../../DataSource";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { ROUTER_HOME } from "../home/Router";
import moment from "moment";
import { FormatFloat } from "@schneiderpp/utils-generic";

interface DetailsState {
    providedOrderId: number | undefined;
    datasource: {
        Details: ParentStateDatasource<typeof Endpoint.Order.GetOrderDetails>;
    };
}

class OrderDetails extends BaseComponent<RouteComponentProps, DetailsState> {
    state: DetailsState = {
        providedOrderId: undefined,
        datasource: {
            Details: DataSourceStateIdle
        }
    };

    private dsDetails = ds(Endpoint.Order.GetOrderDetails, this, "Details", () => this.context);

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const OrderId = urlParams.get("OrderId");
        if (!OrderId) {
            return;
        }
        const OrderIdInt = parseInt(OrderId);
        if (!Number.isInteger(OrderIdInt)) {
            return;
        }
        this.setState({ providedOrderId: OrderIdInt }, () => this.getDetails());
    }

    render() {
        if (!this.state.providedOrderId) {
            return (
                <div className="page">
                    <div className="page__header">Nie wczytano OrderId</div>
                </div>
            );
        }
        const dsDetailsData = this.dsDetails.dataSourceStorage;
        if (dsDetailsData.state === "completed") {
            return (
                <>
                    <div className="header">
                        <Link to={ROUTER_HOME.Orders.List} className="button clear no-left-padding">
                            <span className="button__icon">arrow_back_ios</span> wróć do listy zamówień nagród
                        </Link>
                    </div>
                    <div className="page">
                        <div className="page__column-view">
                            <div className="page__column">
                                <div className="page__header">
                                    Zamówienie nagród nr {dsDetailsData.response.OrderOd} z dnia{" "}
                                    {moment(dsDetailsData.response.OrderDate).format("YYYY-MM-DD")}
                                </div>

                                <div className="page-tab-content">
                                    <div className="page-details">
                                        <div className="page-details__label">Id zamówienia</div>
                                        <div className="page-details__value">{dsDetailsData.response.OrderOd}</div>
                                    </div>
                                    <div className="page-details">
                                        <div className="page-details__label">Status zamówienia</div>
                                        <div className="page-details__value">{dsDetailsData.response.Status.Name}</div>
                                    </div>

                                    {dsDetailsData.response.TrackingLink ? (
                                        <div className="page-details">
                                            <div className="page-details__label">Tracking Link</div>
                                            <div className="page-details__value">
                                                <a href={dsDetailsData.response.TrackingLink}>{dsDetailsData.response.TrackingLink}</a>
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="page-details">
                                        <div className="page-details__label">Data zamówienia</div>
                                        <div className="page-details__value">
                                            {moment(dsDetailsData.response.OrderDate).format("YYYY-MM-DD")}
                                        </div>
                                    </div>
                                    <div className="page-details">
                                        <div className="page-details__label">Wartość nagród</div>
                                        <div className="page-details__value">{FormatFloat(dsDetailsData.response.Value)} PKT</div>
                                    </div>
                                </div>
                            </div>
                            <div className="page__column">
                                <div className="page__header">Zamówione Produkty</div>
                                <div className="page-table">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="w-4 t-left">Nazwa</th>
                                                <th className="w-2">Liczba Sztuk</th>
                                                <th className="w-3">Wartość w PKT.</th>
                                                <th className="w-3 t-right">Suma w PKT.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dsDetailsData.response.Products.map((element) => (
                                                <tr key={element.ProductSizeId}>
                                                    <td className="t-left">{element.Name}</td>
                                                    <td>{element.Quantity}</td>
                                                    <td>{FormatFloat(element.ValuePerPiece)} PKT</td>
                                                    <td className="t-right">{FormatFloat(element.Value)} PKT</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <Overlay {...this.overlayProps} />
                    </div>
                </>
            );
        }
        return (
            <div className="page">
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get overlayProps(): OverlayProps {
        if (this.dsDetails.state === "pending" || this.dsDetails.state === "idle") {
            return {
                show: true,
                title: "Ładowanie"
            };
        }
        if (this.dsDetails.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsDetails.error === "string" ? this.dsDetails.error : "",
                children: (
                    <div className="overlay__children">
                        <button className="button light" onClick={() => this.getDetails()}>
                            spróbuj ponownie
                        </button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private getDetails() {
        if (!this.state.providedOrderId) {
            return;
        }
        this.dsDetails.request({
            params: { OrderId: this.state.providedOrderId }
        });
    }
}

export default withRouter(OrderDetails);
